import React, {forwardRef, KeyboardEvent, RefObject, useCallback, useImperativeHandle, useRef} from 'react'

import TaskFinder from "../../../finder/task/task-finder"
import EntitySelectorPane from "../../content/pane"
import {useEntitySelectorContext} from "../../context"
import {MentionOption} from "../../../editor/plugins/mentions/option"
import {EntityType} from "../../../../gd/const/item"
import {SystemStatusFilter} from "../../../finder/task/@types"

type Props = {
    excludedTasksIds?   : ID[]
}

const debug = false
// const debug = "EntitySelectorTasksList"

// Task > Browse: the project tree with its breadcrumb, unchanged. Searching is
// not routed here -- a query switches the tab to the flat list, so this finder
// only ever shows the tree it was opened on.
//
// `TaskFinder` itself is shared with hosts that know nothing about this selector
// (the task-selector field popover is one), so the context stops here: what it
// needs arrives as props, as it always has.
const EntitySelectorTasksList = forwardRef((props:Props, ref) => {
    const context = useEntitySelectorContext()

    debug && console.log(debug, 'render', props)

    const taskFinderRef:RefObject<any> = useRef()

    const onKeyDown = useCallback((event:KeyboardEvent) => {
        taskFinderRef.current?.onKeyDown(event)
    }, [])

    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    useImperativeHandle(ref, () => ({
        onKeyDown,
    }))

    const onClickTask = useCallback((task: any)=>{
        const option = new MentionOption({
            id  : task.id,
            name: task.title,
            type: EntityType.TASK,
            data: task
        })

        debug && console.log(debug, 'onClickTask', option)

        context.onEntitySelected(option)
    }, [context])

    return (
        <EntitySelectorPane className="entity-selector-list">
            <TaskFinder
                ref                     = {taskFinderRef}
                noHeader                = {true}
                showRecent              = {false}
                alwaysShowHome          = {true}
                parentProjectId         = {context.projectId}
                excludedTasksIds        = {props.excludedTasksIds}
                onClickTask             = {onClickTask}
                onTab                   = {context.onTab}
                systemStatusFilter      = {SystemStatusFilter.ALL}
            />
        </EntitySelectorPane>
    )
})

export default EntitySelectorTasksList
